import { NotificationManager as Notifications } from 'react-notifications';

const Notification = {
  error: (message) => Notifications.error(message, '', 2300),
  info: (message, callback) => Notifications.info(message, '', 9999999999, callback),
  success: (message) => Notifications.success(message, '', 2300),
  warning: (message, callback) => Notifications.warning(message, '', 4000, callback),
};
export default Notification;
